import styled from "@emotion/styled";
import { Box, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { HEADER_AND_TAB_HEIGHT } from "../../ChatInfo.style";

export const SettingsOption = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const SettingsContainer = styled(Box)`
  max-height: calc(100dvh - ${HEADER_AND_TAB_HEIGHT}px);
  overflow: auto;
  padding: 24px;
`;

export const SettingsTypography = styled(Typography)`
  font-weight: bold;
  margin-bottom: 20px;
`;

export const DeleteGroupWrapper = styled(Box)`
  padding: 20px;
`;

export const DeleteIconButton = styled(IconButton)`
  width: 100%;

  &:hover {
    background-color: transparent;
  }
`;

export const ButtonLabel = styled(Typography)`
  color: red;
`;

export const StyledIcon = styled(DeleteIcon)`
  color: red;
`;

export const DeleteGroupStyle = styled(Box)`
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 5px;
`;
